var render = function render(){var _vm=this,_c=_vm._self._c;return _c('carousel',{attrs:{"per-page":1,"mouse-drag":true,"autoplay":true,"loop":true,"per-page-custom":[[480, 1], [768, 3]]}},_vm._l((_vm.json),function(item,i){return _c('slide',{key:i,staticClass:"p-0 p-md-1",attrs:{"index":i}},[_c('Card',{attrs:{"list":item},on:{"carouselreload":_vm.updatePacks}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }